import CollectionService from '../../services/CollectionService';
import toast from 'react-hot-toast';

// ============================================
// ACTION TYPES
// ============================================

// List collections
export const GET_COLLECTIONS_REQUEST = 'GET_COLLECTIONS_REQUEST';
export const GET_COLLECTIONS_SUCCESS = 'GET_COLLECTIONS_SUCCESS';
export const GET_COLLECTIONS_FAILED = 'GET_COLLECTIONS_FAILED';

// List by loan
export const GET_COLLECTIONS_BY_LOAN_REQUEST = 'GET_COLLECTIONS_BY_LOAN_REQUEST';
export const GET_COLLECTIONS_BY_LOAN_SUCCESS = 'GET_COLLECTIONS_BY_LOAN_SUCCESS';
export const GET_COLLECTIONS_BY_LOAN_FAILED = 'GET_COLLECTIONS_BY_LOAN_FAILED';

// Create collection
export const CREATE_COLLECTION_REQUEST = 'CREATE_COLLECTION_REQUEST';
export const CREATE_COLLECTION_SUCCESS = 'CREATE_COLLECTION_SUCCESS';
export const CREATE_COLLECTION_FAILED = 'CREATE_COLLECTION_FAILED';

// Update card status
export const UPDATE_COLLECTION_CARD_STATUS_REQUEST = 'UPDATE_COLLECTION_CARD_STATUS_REQUEST';
export const UPDATE_COLLECTION_CARD_STATUS_SUCCESS = 'UPDATE_COLLECTION_CARD_STATUS_SUCCESS';
export const UPDATE_COLLECTION_CARD_STATUS_FAILED = 'UPDATE_COLLECTION_CARD_STATUS_FAILED';

// Update charges
export const UPDATE_COLLECTION_CHARGES_REQUEST = 'UPDATE_COLLECTION_CHARGES_REQUEST';
export const UPDATE_COLLECTION_CHARGES_SUCCESS = 'UPDATE_COLLECTION_CHARGES_SUCCESS';
export const UPDATE_COLLECTION_CHARGES_FAILED = 'UPDATE_COLLECTION_CHARGES_FAILED';

// Utility actions
export const CLEAR_COLLECTION_ERRORS = 'CLEAR_COLLECTION_ERRORS';
export const RESET_COLLECTION_SUCCESS = 'RESET_COLLECTION_SUCCESS';

// ============================================
// ACTION CREATORS
// ============================================

export const getCollectionsAction = (params = {}) => async (dispatch) => {
    try {
        dispatch({ type: GET_COLLECTIONS_REQUEST });
        const response = await CollectionService.getCollections(params);
        if (response.success) {
            dispatch({ type: GET_COLLECTIONS_SUCCESS, payload: response });
        } else {
            dispatch({ type: GET_COLLECTIONS_FAILED, payload: response.message });
            toast.error(response.message || 'Failed to fetch collections');
        }
    } catch (error) {
        dispatch({ type: GET_COLLECTIONS_FAILED, payload: error.message });
        toast.error(error.message || 'Failed to fetch collections');
    }
};

export const getCollectionsByLoanAction = (loanId, params = {}) => async (dispatch) => {
    try {
        dispatch({ type: GET_COLLECTIONS_BY_LOAN_REQUEST });
        const response = await CollectionService.getCollectionsByLoan(loanId, params);
        if (response.success) {
            dispatch({ type: GET_COLLECTIONS_BY_LOAN_SUCCESS, payload: response });
        } else {
            dispatch({ type: GET_COLLECTIONS_BY_LOAN_FAILED, payload: response.message });
            toast.error(response.message || 'Failed to fetch collections for loan');
        }
    } catch (error) {
        dispatch({ type: GET_COLLECTIONS_BY_LOAN_FAILED, payload: error.message });
        toast.error(error.message || 'Failed to fetch collections for loan');
    }
};

export const createCollectionAction = (data) => async (dispatch) => {
    try {
        dispatch({ type: CREATE_COLLECTION_REQUEST });
        const response = await CollectionService.createCollection(data);
        if (response.success) {
            dispatch({ type: CREATE_COLLECTION_SUCCESS, payload: response.data });
            toast.success(response.message || 'Collection created');
        } else {
            dispatch({ type: CREATE_COLLECTION_FAILED, payload: response.message });
            toast.error(response.message || 'Failed to create collection');
        }
        return response;
    } catch (error) {
        dispatch({ type: CREATE_COLLECTION_FAILED, payload: error.message });
        toast.error(error.message || 'Failed to create collection');
        throw error;
    }
};

export const updateCollectionCardStatusAction = (id, cardStatus, cardReturnedDate = undefined) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_COLLECTION_CARD_STATUS_REQUEST });
        const response = await CollectionService.updateCardStatus(id, cardStatus, cardReturnedDate);
        if (response.success) {
            dispatch({ type: UPDATE_COLLECTION_CARD_STATUS_SUCCESS, payload: response.data });
            toast.success(response.message || 'Card status updated');
        } else {
            dispatch({ type: UPDATE_COLLECTION_CARD_STATUS_FAILED, payload: response.message });
            toast.error(response.message || 'Failed to update card status');
        }
        return response;
    } catch (error) {
        dispatch({ type: UPDATE_COLLECTION_CARD_STATUS_FAILED, payload: error.message });
        toast.error(error.message || 'Failed to update card status');
        throw error;
    }
};

export const updateCollectionChargesAction = (id, chargesPayload) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_COLLECTION_CHARGES_REQUEST });
        const response = await CollectionService.updateCharges(id, chargesPayload);
        if (response.success) {
            dispatch({ type: UPDATE_COLLECTION_CHARGES_SUCCESS, payload: response.data });
            toast.success(response.message || 'Charges updated');
        } else {
            dispatch({ type: UPDATE_COLLECTION_CHARGES_FAILED, payload: response.message });
            toast.error(response.message || 'Failed to update charges');
        }
        return response;
    } catch (error) {
        dispatch({ type: UPDATE_COLLECTION_CHARGES_FAILED, payload: error.message });
        toast.error(error.message || 'Failed to update charges');
        throw error;
    }
};

export const clearCollectionErrors = () => ({ type: CLEAR_COLLECTION_ERRORS });
export const resetCollectionSuccess = () => ({ type: RESET_COLLECTION_SUCCESS });
